import { render, staticRenderFns } from "./AddAsk.vue?vue&type=template&id=3db55052&scoped=true&lang=pug&"
import script from "./AddAsk.vue?vue&type=script&lang=js&"
export * from "./AddAsk.vue?vue&type=script&lang=js&"
import style0 from "./AddAsk.vue?vue&type=style&index=0&id=3db55052&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3db55052",
  null
  
)

export default component.exports